// LanguageContext.jsx

import React, { createContext, useContext } from 'react';

const LanguageContext = createContext();

// Global application UI language is currently English only.
// CAPE-V adaptations are handled separately by CAPEVAdaptationContext.
export const supportedAppLanguages = Object.freeze(['en']);
export const defaultAppLanguage = 'en';

const resourceLanguages = Object.freeze({
  CAPEVR: Object.freeze(['en']),
});

export const LanguageProvider = ({ children }) => {
  const appLanguage = defaultAppLanguage;

  const changeAppLanguage = (lang) => {
    if (!supportedAppLanguages.includes(lang)) {
      return defaultAppLanguage;
    }

    return defaultAppLanguage;
  };

  return (
    <LanguageContext.Provider value={{ appLanguage, changeAppLanguage, resourceLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Hook per accedir fàcilment al context
export const useLanguage = () => useContext(LanguageContext);
